module.exports = {
  apiHost: "https://api.banyanhill.sensoreal.app",
  assetsHost: "https://assets.banyanhill.sensoreal.app",
  contact: {
    address: "Ballina Heights Drive, Cumbalum NSW 2478",
    email: "info@banyanhill.com.au",
    phone: "1300 326 197",
    website: "https://banyanhill.com.au",
  },
  formTemplate: "default",
  header: {
    logo:
      "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/intrapac-edm/BH_LOGO_RGB_Citrus%20Yellow.png",
    text: {
      en: "Your Banyan Hill Selections",
      ar: "",
    },
    color: "#e9fd86",
  },
  langs: [{ code: "en", dir: "ltr" }],
  footerLogo: "",
  links: {
    instagram: "https://www.instagram.com/banyanhill/",
    facebook: "https://www.facebook.com/banyanhill",
    linkedin: "",
    privacy: "https://banyanhill.com.au/our-policies",
    twitter: "",
    youtube: "https://www.youtube.com/@BanyanHill",
  },
  style: {
    primaryColor: "#123332",
    textColor: "#d6f0f5",
  },
};
